import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { Helmet } from "react-helmet";
import Unidades from "./Unidades";
import Unidade from "./Unidade";
import VideoPlayer from "./VideoPlayer";
import Acompanhamento from "./Acompanhamento";
import Coordenacao from "./Coordenacao";

export default function Index({ match }) {
  return (
    <div className="content-wrapper">
      <Helmet>
        <title>Unidades</title>
        <meta name="description" content="Unidades" />
      </Helmet>
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/lista`} />
        <Route path={`${match.url}/lista`} component={Unidades} />
        <Route path={`${match.url}/unidade`} component={Unidade} />
        <Route path={`${match.url}/video`} component={VideoPlayer} />
        <Route path={`${match.url}/coordenacao`} component={Coordenacao} />
        <Route
          path={`${match.url}/acompanhamento`}
          component={Acompanhamento}
        />
      </Switch>
    </div>
  );
}
